export const INVOICE_ACTION_KEYS = {
  EDIT: 'edit',
  POST: 'post',
  POST_AND_SEND: 'postAndSend',
  ADD_TO_GROUP: 'addToGroup',
  REMOVE_FROM_GROUP: 'removeFromGroup',
  DELETE: 'delete',
  REGENERATE: 'regenerate',
  REGENERATE_AND_REPOST: 'regenerateAndRepost',
  EMAIL: 'email',
  CUSTOM_EMAIL: 'customEmail',
  MAKE_PAYMENT: 'makePayment',
  REVERT_TO_DRAFT: 'revertToDraft',
  REVERT_CREDIT_MEMO_TO_DRAFT: 'revertCreditMemoToDraft',
  DELETE_UNPAID: 'deleteUnpaid',
  MOVE_TO_ACCOUNT_CREDIT: 'moveToAccountCredit',
}

export const CONFIRMATION_ACTION_KEYS = {
  CONFIRM_DELETE: 'confirmDelete',
  CONFIRM_DELETE_UNPAID: 'confirmDeleteUnpaid',
  CONFIRM_REGENERATE: 'confirmRegenerate',
  CONFIRM_REVERT_TO_DRAFT: 'confirmRevertToDraft',
  CONFIRM_REVERT_CREDIT_MEMO_TO_DRAFT: 'confirmRevertCreditMemoToDraft',
}

export const ALL_ACTION_KEYS = {
  ...INVOICE_ACTION_KEYS,
  ...CONFIRMATION_ACTION_KEYS,
}
